const utils = (type, str, q) => {
  switch (type) {
    case "countTotalWord":
      return countTotalAmountOfMachedWordString(str, q);
    case "isObjectEmpty":
      return isObjectEmpty(str);
    default:
      return ;
  }
};

function countTotalAmountOfMachedWordString(str, q) {
  if (!str || !q) return 0

  let re = new RegExp(q, 'gi')
  const res = str.match(re);
  if (res) return res.length
  return 1
}

function isObjectEmpty(obj){
  return Object.keys(obj).length === 0
}

export default utils